import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class criminaldefense extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​

                ​


















            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >



                    {lang==="en" &&  <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Criminal Defense and Investigations</span><p/>
                        <span style={{fontSize: ".8em"}}>In the Morrow Firm's criminal defense and investigations practice, we leverage our prior criminal prosecution experience to serve our clients facing white collar criminal investigation or prosecution.<br/> <br/>Before private practice, our founding attorney Xinlin Morrow served as an attorney fellow at the Hardcore Gang Division of the Los Angeles District Attorney's Office and helped prosecute gang-related murders, including the successful prosecution of a twenty-year cold case. More recently, Ms. Morrow tried two misdemeanor cases as a special deputy city attorney at the Anaheim City Attorney’s Office and obtained guilty verdicts in both.</span><br/><br/>

                        <span style={{fontSize: ".8em"}}>Representative experience:</span><br/>
                        ​

                        <ul><span style={{fontSize: ".8em"}}><li>Served as lead counsel representing a businessman in a state criminal investigation of campaign finance fraud and successfully avoided criminal prosecution.</li></span><br/>
                        <span style={{fontSize: ".8em"}}><li>Represented an executive in a federal criminal investigation related to illegal importation, money laundering, and tax fraud.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented a Forbes five-star Hollywood hotel in multiple highly publicized forfeiture actions brought by the U.S. Department of Justice based on the underlying criminal charge of money laundering.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented a Fortune 500 executive facing insider trading and money laundering charges in parallel civil and criminal proceedings.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented a Fortune 500 executive facing allegations of Foreign Corrupt Practice Act (FCPA) violations.</li></span><br/>
                    <span style={{fontSize: ".8em"}}><li>Represented a director of a NASDAQ-listed company in a securities fraud investigation by the SEC.</li></span><br/></ul>
            </div>}
                    { lang==="zh" && <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>白领犯罪辩护与调查</span><p/>
                        <span style={{fontSize: ".8em"}}>在沫若律师事务所的刑事辩护和调查业务中，我们运用以前的刑事诉讼检察官经验为面临白领刑事调查或起诉的客户提供服务。在律师事务所执业之前，我们的创始律师李馨霖曾在洛杉矶地区检察官办公室任职并帮助起诉与黑帮有关的谋杀案，包括成功起诉一起二十年前发生的冷案。最近，李律师作为安纳海姆市检察官办公室的特别检察官审理了两起轻罪案，皆获得有罪判决。</span><br/><br/>

                        <span style={{fontSize: ".8em"}}>代表经验：</span><br/>
                        ​

                        <ul><span style={{fontSize: ".8em"}}><li>作为首席律师代表一名商务人士参与加州检察官对其竞选财务欺诈的刑事调查的辩护，并成功避免了刑事起诉。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一名高管参与涉及非法进口、洗钱和税务欺诈的联邦刑事调查。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一家福布斯五星级好莱坞酒店参与美国司法部根据洗钱的基本刑事指控提起的没收进行辩护。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一位财富500强企业高管在民事和刑事诉讼中面临内幕交易和洗钱指控进行辩护。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一位财富500强的高管面临违反“反海外腐败法”（FCPA）的指控进行辩护。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一家纳斯达克上市公司的董事参与美国证券交易委员会的证券欺诈调查。</li></span><br/></ul>
                    </div>}


            <div style={{width: "49%", maxWidth:"50%",  height:"100%", verticalAlign:"top",minWidth:"20em", display: "inline-block",  padding: "5px", top:"0px", }} ><img  alt="Criminal Defense and Investigations" style={{top:"0px", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/criminal.jpg?alt=media&token=d394a049-e021-4458-832c-af4cca1f909b"/>

            </div>
            </div>
            </div>
            <SiteFoot lang={lang}/>
        </div>


    );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, { getUser })(criminaldefense);



// WEBPACK FOOTER //
// ./src/Containers/criminaldefense.js